import React, { Component} from 'react';
import { connect } from 'react-redux';
import { actions } from 'react-redux-form';
import { getAdminFeatureToggle, updateAdminFeatureToggle } from '../../../../actions/feature-toggles';
import { destandard } from '../../../../utils/commonFunctions';
import PageTitle from "../../../common/page-title";
import FeatureToggleForm from './feature-toggle-form';

const model = 'deep.admin_feature_toggle_save';

class FeatureToggleFormPage extends Component {
  constructor(props) {
    super(props);

    const { match } = this.props;

    this.id = match.params.id;
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAdminFeatureToggle(this.id)).then(() => {
      const { featureToggle } = this.props;
      const data = destandard({
        ...featureToggle.attributes
      });
      
      dispatch(actions.load(model, data));
    });
	}

  handleSubmit = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, updateAdminFeatureToggle(this.id, payload)));
  }

	render() {
    const { isLoading } = this.props;

		return(
			<div className="container-fluid">
				<PageTitle>Feature Toggle</PageTitle>
        {isLoading ? 'Loading...' : <FeatureToggleForm model={model} onSubmit={this.handleSubmit} />}
			</div>
		)
	}
}

const mapStateToProps = (state) => ({
  isLoading: !state.featureToggles.fetched && state.featureToggles.fetching,
  featureToggle: state.featureToggles.featureToggle,
});

export default connect(mapStateToProps)(FeatureToggleFormPage);



// WEBPACK FOOTER //
// ./src/components/admin/feature-toggles/form/feature-toggle-form-page.jsx